import { render, staticRenderFns } from "./certificateInfo.vue?vue&type=template&id=72af3c17&scoped=true&"
import script from "./certificateInfo.vue?vue&type=script&lang=js&"
export * from "./certificateInfo.vue?vue&type=script&lang=js&"
import style0 from "./certificateInfo.vue?vue&type=style&index=0&id=72af3c17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af3c17",
  null
  
)

export default component.exports